import {RequestResult, RequestResultValue} from "../../common/api/requestResult";
import {HttpService} from "../../common/api/httpService";
import {ServerSetting} from "../../models/serverSetting";
import {PaginationResponse} from "../../models/paginationResponse";

export async function serverSettingsListApi(page: number, count: number): Promise<RequestResultValue<PaginationResponse<ServerSetting>>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/serverSettings`, JSON.stringify({
        page: page,
        count: count
    }));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSON.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<PaginationResponse<ServerSetting>>(true, body as PaginationResponse<ServerSetting>);
    }
    return new RequestResultValue<PaginationResponse<ServerSetting>>(false);
}

export async function serverSettingsDeleteApi(key: string): Promise<RequestResult> {
    let url = `admin/serverSettings/${key}`;
    const response = await HttpService.getInstance().requestDeleteAsync(url);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResult(true);
    }
    return new RequestResult(false);
}

export async function serverSettingsAddApi(key: string, value: string, description?: string)
    : Promise<RequestResultValue<ServerSetting>> {
    const response = await HttpService.getInstance().requestPostAsync(`admin/serverSettings/add`, JSON.stringify({
        key: key,
        value: value,
        description: description || null
    }));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSON.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<ServerSetting>(true, body as ServerSetting);
    }
    return new RequestResultValue<ServerSetting>(false);
}

export async function serverSettingsUpdateApi(key: string, value: string, description?: string)
    : Promise<RequestResultValue<ServerSetting>> {
    const response = await HttpService.getInstance().requestPutAsync(`admin/serverSettings/update`, JSON.stringify({
        key: key,
        value: value,
        description: description || null
    }));
    const text = await response.text(); // Получаем сырой текст ответа
    const body = JSON.parse(text);
    if (response.status >= 200 && response.status < 300) {
        return new RequestResultValue<ServerSetting>(true, body as ServerSetting);
    }
    return new RequestResultValue<ServerSetting>(false);
}